import axios from 'axios'
import feathers from '@feathersjs/client';
import auth from '@feathersjs/client/dist/authentication';

// Get REST client
var rest = feathers.rest;
const app = feathers();
const restClient = rest(process.env.VUE_APP_SERVER_URL);

app.configure(restClient.axios(axios));
app.configure(auth({ storage: window.localStorage }));

const errorHandler = error => {
	app.authenticate({
	  strategy: 'local',
	  email: 'admin@feathersjs.com',
	  password: 'admin'
	}).then(response => {
	  // You are now authenticated again
	});
};
  
// Handle when auth fails during a reconnect or a transport upgrade
app.on('reauthentication-error', errorHandler)

//
/*axios.interceptors.response.use(res => res, err => { 
	if (err.response.status == 401) {
		window.location.href = '/login'
	}
	
	return Promise.reject(err); 
});*/

class Ajax {
	get(path, options) {
	    return axios.get(process.env.serverURL + path, options);
	}
	
	post(path, data, options) {
	    return axios.post(process.env.serverURL + path, data, options);
	}
	
	handle(other = undefined) {
		return (error) => {
			if (error.response.status == 403) {
				
			}
		}
	}
}

export default {
	install: (Vue, options) => {
		Vue.prototype.$app = app;
	}
};